import React from 'react';

const Triangle = ({ size = 1 }: { size?: number }) => (
  <svg width={`${size}em`} viewBox="0 0 8 5" aria-hidden="true" focusable="false">
    <path fill="currentColor" d="M0 0.600098L4 4.6001L8 0.600098L0 0.600098Z" />
  </svg>
);

export default Triangle;
